'use client';

import { memo } from 'react';

import { LoadingSkeletonProps } from '@/features/v2/casino/interfaces/component.interface';

function LoadingSkeleton({ count = 12 }: Readonly<LoadingSkeletonProps>) {
  return (
    <div className="m-6">
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 min-[1280px]:grid-cols-4 gap-4">
        {Array.from({ length: count }, (_, index) => {
          return (
            <div key={`skeleton-${index}-${count}`} className="bg-default-50 rounded-lg overflow-hidden animate-fade">
              <div className="aspect-245/184 bg-default-200" />
              <div className="p-2 space-y-1.5">
                <div className="h-3 bg-default-200 rounded w-3/4" />
                <div className="h-2.5 bg-default-200 rounded w-1/2" />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default memo(LoadingSkeleton);
